import React from 'react';
import { SSO_PROVIDERS } from 'constants/auth';
import GoogleIcon from 'assets/icons/google.svg';
import AppleIcon from 'assets/icons/apple.svg';
import FacebookIcon from 'assets/icons/facebook.svg';

const IconSocial = ({ provider = '', isLocked = false }) => {
  const iconsPreset = {
    [SSO_PROVIDERS.GOOGLE]: GoogleIcon,
    [SSO_PROVIDERS.FACEBOOK]: FacebookIcon,
    [SSO_PROVIDERS.APPLE]: AppleIcon,
  };
  return Object.values(SSO_PROVIDERS).includes(provider) ? (
    <button className="w-16 h-16 border-2 rounded-full text-2xl font-bold hover:not-disabled:outline-2 hover:not-disabled:cursor-pointer disabled:opacity-25" disabled={isLocked}>
      <img src={iconsPreset[provider]} alt="Logo" className="w-6 h-auto mx-auto" />
    </button>
  ) : null;
};

export default IconSocial;
